import React, { Component } from 'react';

// eslint-disable-next-line no-unused-vars
import _ from 'lodash';
import { StepCard } from '..';

class Type extends Component {

  constructor(props) {
    super(props);

    this.state = {
    };
  }

  toggleModelsModal = () => {
    this.setState(prevState => ({ modelsModal: !prevState.modelsModal }));
  };

  toggleCancelModal = () => {
    this.setState(prevState => ({ cancelModal: !prevState.cancelModal }));
  };

  toggleModalCharacters = () => {
    this.setState(prevState => ({ charactersModal: !prevState.charactersModal }));
  };



  renderDescription = () => {
    const { step, sms, push } = this.props;

    if (sms) {
      return (
        <div className="font-size-13" style={{ color: '#36474f' }}>
          <strong>
            SMS: 
            {' '}
            {sms.nome}
            <br />
            Push:
            {' '}
            {push.nome}
          </strong>
        </div>
      );
    }

    return step.description;
  };

  render() {
    const { step,} = this.props;

    return (
      <StepCard
        onRef={(ref) => {
          this.stepCardRef = ref;
        }}
        title={step.title}
        description={this.renderDescription()}
        disabled
        isFinished
      />
    );
  }
}

export default Type;



// WEBPACK FOOTER //
// ./src/components/campaigns/Type.js